import { ProductPageLayout } from '../components/ProductPageLayout';

export function HiggsfieldAiPage() {
    return <ProductPageLayout productId="higgsfield-ai" />;
}
